import { Stack } from '@mui/material';
import { GeneralListLayout } from 'components/layouts';
import { useI18n } from 'locales';
import PortalHeader from '../components/PortalHeader';
import { apiUrl, getToken } from '@/redux/apis';

const defaultListParams = {
  sort: 'receiptNumber',
  order: 'desc',
};

function PortalReceiptPage() {
  const t = useI18n();
  return (
    <>
      <PortalHeader header={t('TAX RECEIPTS')} />

      <Stack gap={2} sx={{ px: 2, py: 3 }}>
        <GeneralListLayout
          model="Receipt"
          title={t('ISSUED TAX RECEIPTS')}
          defaultListParams={defaultListParams}
          onView={(row) => {
            window.open(`${apiUrl}/giver/receipts/${row.id}/download?token=${getToken()}`, '_blank');
          }}
        />
      </Stack>
    </>
  );
}

export default PortalReceiptPage;
